module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.panelFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [(_vm.viewFlag) ? _c('div', [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls col-md-offset-2"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                                    \"paging\": {\r\n                                    \"enabled\": true\r\n                                    },\r\n                                    \"filtering\": {\r\n                                    \"enabled\": true\r\n                                    },\r\n                                    \"sorting\": {\r\n                                    \"enabled\": true\r\n                                    }}"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Date of Transaction")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_payment_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Ref")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_payment_ref))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction @")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_module_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Amount")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_amount_paid))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_type_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Mode")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_mode_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Mode Transaction Ref")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_mode_transaction_ref))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Payer Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_payer_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Payer Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_payer_email))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Payer Phone")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_payer_phone))])]), _vm._v(" "), (_vm.transaction.transaction_payer_user_name != 'error') ? _c('tr', [_c('th', [_vm._v("Transaction User Account")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_payer_user_name))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Payment Ref")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_payment_ref))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Payer Date")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_payment_date))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]) : _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [(_vm.transactions) ? _c('h3', [_vm._v(_vm._s(_vm.todays_count))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n          CNpayments and Transactions\r\n        ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n            \"paging\": {\r\n              \"enabled\": true\r\n            },\r\n            \"filtering\": {\r\n              \"enabled\": true\r\n            },\r\n            \"sorting\": {\r\n              \"enabled\": true\r\n            }}"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.transactions), function(transaction, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.transaction_payment_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.transaction_payment_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.transaction_module_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.transaction_payer_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.transaction_amount_paid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.transaction_mode_name))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', transaction)
        }
      }
    }, [_vm._v("View")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                                    Transaction Details\r\n                                    "), _c('a', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "href": "cnpayments"
    }
  }, [_vm._v("Back")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-money-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("REF.")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("Transaction")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("Payer")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs sm md"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs sm md"
    }
  }, [_vm._v("Mode")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68443070"}!./src/components/CNpayments/template.html
// module id = 162
// module chunks = 0